import { Link } from "react-router-dom";
import constants from "@constants/constants";
import { CreateCandidatePageLink, CreateSitePageLink } from "utils/page-link-generator";

const {
  PAGE_ROUTES: { STS_ROUTE }
} = constants;

function GlobalNavigation({ type, data }) {
  if (type === "Person") {
    return (
      <CreateCandidatePageLink
        mode="edit"
        personObjectId={data?.ObjectId}
        candidateObjectId={data?.CandidateList[0]?.ObjectId}
        candidateName={data?.Name}
        replace={true}
        target="_blank"
        rel="noopener noreferrer"
      >
        {data?.Name}
      </CreateCandidatePageLink>
    );
  }
  if (type === "Site") {
    return (
      <CreateSitePageLink
        mode="edit"
        target="_blank"
        ObjectId={data?.ObjectId}
        personObjectId={data?.ObjectId}
        Name={encodeURIComponent(data?.Name)}
      >
        {data?.Name}
      </CreateSitePageLink>
    );
  }
  if (type === "Supplier") {
    return (
      <Link to={STS_ROUTE} target="_blank" rel="noopener noreferrer">
        <a className="name-label">{data?.Name}</a>
      </Link>
    );
  }
}

export default GlobalNavigation;
